/** Phasen der Baustellenfotos — Wörter in der Oberfläche und der Vorschlag aus den Terminen. */
import type { FotoPhase } from "../../hooks/useMedien";

export const PHASEN: { wert: FotoPhase; text: string }[] = [
  { wert: "bestandsaufnahme", text: "Vorher" },
  { wert: "verlauf", text: "Arbeitstag" },
  { wert: "ergebnis", text: "Nachher" },
  { wert: "sonstiges", text: "Sonstiges" },
];
export const PHASE_TEXT = Object.fromEntries(PHASEN.map((p) => [p.wert, p.text])) as Record<FotoPhase, string>;

/** Dieselbe Regel wie `foto_eingang.phase_fuer` auf dem Server. */
export function phaseVorschlag(tage: string[], tag: string): FotoPhase {
  const t = [...tage].sort();
  if (!t.length) return "bestandsaufnahme";
  if (tag < t[0]) return "bestandsaufnahme";
  if (tag > t[t.length - 1]) return "ergebnis";
  return "verlauf";
}

export const kurzTag = (iso: string) => {
  const d = new Date(iso.length <= 10 ? `${iso}T12:00:00` : iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });
};
